import { useState } from "react";
import { MapPicker } from "./MapPicker";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const NO_SPOT = "__none";

export function CatchForm({ initial = {}, spots = [], onSubmit, submitLabel = "Save catch", busy = false }) {
  const [f, setF] = useState({
    species: initial.species || "",
    length_in: initial.length_in ?? "",
    bait: initial.bait || "",
    spot_id: initial.spot_id || "",
    spot_name: initial.spot_id ? "" : initial.spot_name || "",
    notes: initial.notes || "",
  });
  const [pin, setPin] = useState(initial.lat != null ? { lat: initial.lat, lng: initial.lng } : null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const pickSpot = (id) => {
    const spot = spots.find((s) => s.id === id);
    setF({ ...f, spot_id: id === NO_SPOT ? "" : id });
    if (spot) setPin({ lat: spot.lat, lng: spot.lng });
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit({
      species: f.species.trim(),
      length_in: f.length_in === "" ? null : Number(f.length_in),
      bait: f.bait.trim() || null,
      spot_id: f.spot_id || null,
      spot_name: f.spot_id ? null : f.spot_name.trim() || null,
      notes: f.notes.trim() || null,
      lat: pin?.lat ?? null,
      lng: pin?.lng ?? null,
    });
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="catch-form">
      <div className="grid grid-cols-3 gap-3">
        <div className="col-span-2">
          <label className="brut-label">Species</label>
          <input className="brut-input" required value={f.species} onChange={set("species")} data-testid="catch-species-input" />
        </div>
        <div>
          <label className="brut-label">Length (in)</label>
          <input className="brut-input" type="number" step="0.1" min="0" inputMode="decimal" value={f.length_in}
            onChange={set("length_in")} data-testid="catch-length-input" />
        </div>
      </div>
      <div>
        <label className="brut-label">Bait / lure</label>
        <input className="brut-input" placeholder="Live shrimp, soft plastic…" value={f.bait} onChange={set("bait")} data-testid="catch-bait-input" />
      </div>
      <div className="space-y-2">
        <label className="brut-label">Spot</label>
        {spots.length > 0 && (
          <Select value={f.spot_id || NO_SPOT} onValueChange={pickSpot}>
            <SelectTrigger className="brut-input h-[52px] rounded-none" data-testid="catch-spot-select"><SelectValue /></SelectTrigger>
            <SelectContent className="rounded-none border-2 border-[#FF4D00]">
              <SelectItem value={NO_SPOT}>Not a saved spot</SelectItem>
              {spots.map((s) => <SelectItem key={s.id} value={s.id} data-testid={`catch-spot-option-${s.id}`}>{s.name}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
        {!f.spot_id && (
          <input className="brut-input" placeholder="Spot name (optional)" value={f.spot_name} onChange={set("spot_name")} data-testid="catch-spot-name-input" />
        )}
      </div>
      <div>
        <label className="brut-label">Where you caught it</label>
        <MapPicker value={pin} onChange={setPin} testId="catch-map" />
      </div>
      <div>
        <label className="brut-label">Notes</label>
        <textarea className="brut-input py-3 min-h-[96px]" value={f.notes} onChange={set("notes")} data-testid="catch-notes-input" />
      </div>
      <button className="brut-btn w-full" disabled={busy || !f.species.trim()} data-testid="catch-form-submit-btn">
        {busy ? "Saving…" : submitLabel}
      </button>
    </form>
  );
}
